import { render, staticRenderFns } from "./PokemonProgressBar.vue?vue&type=template&id=4bd85c52&scoped=true"
import script from "./PokemonProgressBar.vue?vue&type=script&lang=js"
export * from "./PokemonProgressBar.vue?vue&type=script&lang=js"
import style0 from "./PokemonProgressBar.vue?vue&type=style&index=0&id=4bd85c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd85c52",
  null
  
)

export default component.exports